import { UserCookieAcceptance } from '../../../features/user/queries';
import { createContext, Dispatch, SetStateAction } from 'react';

export interface CookieContextProps {
  isOpen: boolean;
  initialStep: 1 | 2 | undefined;
  getUserCookieAcceptance: UserCookieAcceptance[];
  isLoaded?: boolean;
  setCookieConfig?: Dispatch<SetStateAction<CookieContextProps>>;
}

export const CookieContext = createContext<CookieContextProps>({
  isLoaded: false,
  isOpen: false,
  initialStep: undefined,
  setCookieConfig: undefined,
  getUserCookieAcceptance: [],
});
